<template>
  <div>
    <TranList appID="MD" :id="id" :memberQuery="query"></TranList>
  </div>
</template>

<script>
import TranList from './transactionList'

export default {
  data: () => ({
    query: false
  }),
  created() {
    if (this.$route.name === 'maidTranListQuery') {
      this.query = true
    } else {
      this.query = false
    }
  },
  components: {
    TranList
  },
  props: ['id', 'appID']
}
</script>

<style>
</style>
